import { useState } from "react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { US_STATES } from "../lib/site";
import { Label, Segmented, SubmitRow, Success, card, field, useSubmit } from "./FormBits";

const EMPTY = { full_name: "", email: "", phone: "", age: "", tobacco: "non-smoker", state: "", amount_type: "coverage_amount", amount: "" };

export const LifeQuoteForm = () => {
  const [f, setF] = useState(EMPTY);
  const { loading, done, setDone, submit } = useSubmit("/quotes/life");
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const isBudget = f.amount_type === "monthly_budget";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!f.state) return toast.error("Please select your state.");
    const ok = await submit({ ...f, age: Number(f.age), amount: Number(f.amount) });
    if (ok) setF(EMPTY);
  };

  if (done) return <Success onReset={() => setDone(false)} testid="life-quote-success" />;

  return (
    <form onSubmit={onSubmit} data-testid="life-quote-form" className={card}>
      <p className="font-serif-d text-3xl text-[#0B281E] mb-1">Life insurance quote</p>
      <p className="text-sm text-[#52635B] mb-8">Final Expense, IUL or Whole Life — a few details and I'll price the options.</p>
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="sm:col-span-2"><Label htmlFor="ln">Full name</Label><Input id="ln" required minLength={2} value={f.full_name} onChange={set("full_name")} placeholder="Jane Doe" className={field} data-testid="life-name-input" /></div>
        <div><Label htmlFor="la">Age</Label><Input id="la" type="number" required min={18} max={100} value={f.age} onChange={set("age")} placeholder="45" className={field} data-testid="life-age-input" /></div>
        <div><Label>Tobacco use</Label><Segmented value={f.tobacco} onChange={set("tobacco")} options={[["non-smoker", "Non-smoker"], ["smoker", "Smoker"]]} testid="life-tobacco" /></div>
        <div className="sm:col-span-2">
          <Label>State</Label>
          <Select value={f.state} onValueChange={set("state")}>
            <SelectTrigger className={field} data-testid="life-state-select"><SelectValue placeholder="Select your state" /></SelectTrigger>
            <SelectContent className="max-h-72 bg-white" data-lenis-prevent>{US_STATES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div><Label>I'd like to share my</Label><Segmented value={f.amount_type} onChange={set("amount_type")} options={[["coverage_amount", "Coverage amount"], ["monthly_budget", "Monthly budget"]]} testid="life-amount-type" /></div>
        <div>
          <Label htmlFor="lam">{isBudget ? "Monthly budget ($)" : "Desired coverage ($)"}</Label>
          <Input id="lam" type="number" required min={1} step="any" value={f.amount} onChange={set("amount")} placeholder={isBudget ? "75" : "250000"} className={field} data-testid="life-amount-input" />
        </div>
        <div><Label htmlFor="le">Email</Label><Input id="le" type="email" required value={f.email} onChange={set("email")} placeholder="jane@email.com" className={field} data-testid="life-email-input" /></div>
        <div><Label htmlFor="lp">Phone</Label><Input id="lp" type="tel" required minLength={7} value={f.phone} onChange={set("phone")} placeholder="(555) 123-4567" className={field} data-testid="life-phone-input" /></div>
      </div>
      <SubmitRow loading={loading} label="Get my life quote" testid="life-quote-submit" />
    </form>
  );
};
